// extracted by mini-css-extract-plugin
export default {"btn":"BackButton_btn__-A+UD","icon":"BackButton_icon__E24mJ","text":"BackButton_text__+EHe0","v_ghost":"BackButton_v_ghost__poQnk","v_icon":"BackButton_v_icon__BGjEm"};